import styled from 'styled-components/macro';

export const DeleteIconWrapper = styled.div`
  position: absolute;
  top: 21px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
  z-index: 10;

  &:hover {
    transform: scale(1.1);
  }
`;

export const BackgroundCardWrapper = styled.div<{ default?: boolean }>`
  position: relative;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(33% - 24px);
  max-width: 287px;
  opacity: 1;
  overflow: hidden;
  box-shadow:
    0px 6px 12px 0px rgba(66, 79, 104, 0.06),
    0px 0px 4px 0px rgba(66, 79, 104, 0.08);
  background: ${props => props.theme.colors.white[100]};
  border: ${props =>
    props.default
      ? `1px solid ${props.theme.colors.primary[100]}`
      : `1px solid ${props.theme.colors.neutral[20]}`};

  &:hover ${DeleteIconWrapper} {
    opacity: 1;
    visibility: visible;
  }
`;

export const BackgroundName = styled.div`
  color: ${props => props.theme.colors.neutral[100]};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardImage = styled.img`
  height: 168px;
  width: 100%;
  object-fit: cover;
`;

export const CardImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: 168px;
  object-fit: cover;
`;

export const SystemDefaultWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 1;
`;

export const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 16px 0 32px 0;
  width: 100%;
`;

export const Dot = styled.button<{ active?: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  padding: 0;

  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary[100] : theme.colors.neutral[40]};

  transition: background-color 0.2s ease;
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const ArrowButton = styled.button<{ left?: boolean }>`
  position: absolute;
  top: calc(50% - 16px);
  transform: translateY(-50%);
  ${({ left }) => (left ? 'left: -36px;' : 'right: -36px;')}

  width: 36px;
  height: 36px;
  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.secondary[40]};

  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.secondary[80]};
  }
`;
